export function getRouteBasedFinanceTitles() {
  return {
    default: 'Finance',
    details: 'Finance Data Sources',
    main: 'All Transactions',
    recon: 'Reconciliation',
    securities: 'All Securities',
  };
}
